import {DEFAULT_ERROR_TITLE, ERROR_SESSION_EXPIRED, ERROR_BAD_SESSION, API_EXCEPTION, API_OK, API_URL, DEFAULT_ERROR_TEXT} from './Constants'
import cookie from "js-cookie";
import axios from "axios";

// Show Israeli numbers in local format: +972/972 prefix → leading 0
export function formatLocalPhone(phone){
    if(phone === null || phone === undefined){
        return phone;
    }
    let p = String(phone).trim();
    p = p.replace(/^\+?972/, '0');
    return p;
}

export function formatErrorMessage(errorMessage, t){
    const translatedErrorMessage = t(errorMessage);
    if (translatedErrorMessage !== errorMessage){
        errorMessage = errorMessage + " - " + translatedErrorMessage;
    }
    return errorMessage;
}

export function handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate, showOnPage = "all") {
    const sessionErrors = [
        ERROR_SESSION_EXPIRED,
        ERROR_BAD_SESSION
    ];

    if(sessionErrors.includes(errorMessage)
        && (logout !== null)){
        if((errorMessage !== ERROR_SESSION_EXPIRED) && (typeof errorMessage !== 'undefined')){
            cookie.set('logout_error', errorMessage);
        }
        
        dispatch(logout());
        navigate("/", { replace: true });
    }else{
        if(typeof errorMessage !== 'undefined'){
            errorMessage = formatErrorMessage(errorMessage, t);
            dispatch(showErrorDialog({title : t(DEFAULT_ERROR_TITLE), text: errorMessage, page: showOnPage}));
        }
    }
}

export async function getCommunityGeneralInfo(loginToken, t, dispatch, showErrorDialog, logout, navigate){
    let  headers = {
        token: loginToken
      }
    let errorMessage = t(DEFAULT_ERROR_TEXT);
    let generalInfo = {};
    await axios.get(API_URL + '/getStat', {headers})
      .then(
        ({ data }) => {
          if(data.hasOwnProperty("responseStatus") && (data['responseStatus'] === API_OK)){
            generalInfo =
            {
              activeLines:data.active_lines,
              activeCustomers:data.active_customers,
              membersListHidden: data.membersListHidden ?? false,
              portalAccess: data.portalAccess ?? {},
              blockListPolicy: data.blockListPolicy ?? { direction: 'BOTH', status: 'BOTH' },
              blockListMode: {incoming: data.blockListMode.incoming, outcoming: data.blockListMode.outcoming},
              name: data.name,
              note: data.note,
              smsWatchSystemAllow: data.smsWatchSystemAllow,
              showRedInactiveLines: data.showRedInactiveLines,
              allowUnblockLineFromInvalidImei: data.allowUnblockLineFromInvalidImei,
              myCategories: data.myCategories ?? [],
              networkName: data.networkName ?? null,
              webConfig: data.webConfig ?? null,
              communityType: data.community_type ?? 'REGULAR',
              isSupervision: data.isSupervision ?? (data.community_type === 'SUPERVISION'),
              nick: data.nick ?? null,
              supervisionInfo: data.supervisionInfo ?? null,
            };
          }else{
            if((data.responseStatus === API_EXCEPTION) && (data.hasOwnProperty("message"))){
              errorMessage = data["message"];
            }
            handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          }
        }).catch((error) => {
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
      });
    return generalInfo;
}

/**
 * גישת הקהילה למקטעי הפורטל (portal_access) כפי שנשמרה ב-localStorage בעת הכניסה/רענון הדשבורד.
 * מקטע מ-{members, watch, blocks, permissions, anti_spam} עם ערך true = חסום לקהילה (נאכף גם קשיח בשרת).
 */
export function getPortalAccess() {
    try { return JSON.parse(localStorage.getItem('portal_access') || '{}') || {}; }
    catch { return {}; }
}

/** האם מקטע פורטל נתון חסום לקהילה. */
export function isSectionDisabled(section) {
    return getPortalAccess()[section] === true;
}

/**
 * מדיניות הגדרות החסימה של הקהילה (block_list_policy) מ-localStorage — {direction, status}.
 * direction: BOTH/IN/OUT ; status: BOTH/OPEN/BLOCKED. ברירת מחדל BOTH/BOTH (ללא הגבלה). נאכף גם קשיח בשרת.
 */
export function getBlockListPolicy() {
    try {
        const p = JSON.parse(localStorage.getItem('block_list_policy') || '{}') || {};
        return { direction: p.direction || 'BOTH', status: p.status || 'BOTH' };
    } catch {
        return { direction: 'BOTH', status: 'BOTH' };
    }
}

/** ערכי הסטטוס המותרים ליצירת רשומת חסימה חדשה ('BLOCKED'/'OPEN'), לפי מדיניות הקהילה. */
export function allowedBlockStatuses() {
    const p = getBlockListPolicy();
    return p.status === 'OPEN' ? ['OPEN'] : p.status === 'BLOCKED' ? ['BLOCKED'] : ['BLOCKED', 'OPEN'];
}

/** סוגי השיחה המותרים ליצירת רשומת חסימה חדשה ('OUT'/'IN'/'ALL'), לפי מדיניות הקהילה. */
export function allowedBlockCallTypes() {
    const p = getBlockListPolicy();
    return p.direction === 'IN' ? ['IN'] : p.direction === 'OUT' ? ['OUT'] : ['OUT', 'IN', 'ALL'];
}

/** מסנן אובייקט values={key:label} של Switch/Select להשארת המפתחות המותרים בלבד (למעט current, שנשמר לתצוגת ערך קיים). */
export function filterAllowed(values, allowedKeys, current) {
    const out = {};
    Object.keys(values).forEach(k => { if (allowedKeys.includes(k) || k === current) out[k] = values[k]; });
    return out;
}